import Image from 'next/image';
import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable } from '@/design-system/components/ui';

import { STRIPE_PAYMENT_EVENT_TYPE_LABELS, StripePaymentEventType, Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function StripePaymentTriggerFullDetails({ trigger }: Props) {
  const paymentEventTypeLabel = useMemo(() => {
    const paymentEventType = trigger.context?.paymentEventType;
    if (!paymentEventType) {
      return '-';
    }
    return STRIPE_PAYMENT_EVENT_TYPE_LABELS[paymentEventType as StripePaymentEventType] ?? paymentEventType;
  }, [trigger.context]);

  const providerDisplay = useMemo(() => {
    return (
      <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
        <Image src="/assets/svg/stripe.svg" alt="Stripe" width={20} height={20} />
        <span>Stripe</span>
      </div>
    );
  }, []);

  const paymentEventDisplay = useMemo(() => {
    if (paymentEventTypeLabel === '-') {
      return '-';
    }
    return <Badge variant="default">{paymentEventTypeLabel}</Badge>;
  }, [paymentEventTypeLabel]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Provider" value={providerDisplay} />
      <KeyValueRow label="Payment event" value={paymentEventDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
